import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { CampaignReportServiceService } from 'app/core/services/campaign-report.service';
import { MappingService } from 'app/core/services/mapping.service';
import { UpdateCampaignNameServiceService } from 'app/core/services/update-campaign-name.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
    selector: 'update-campaign-name',
    templateUrl: './update-campaign-name.component.html',
    styleUrls: [],
})
export class UpdateCampaignNameComponent implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput: ElementRef;
  @Input() activePage:'campaign' | 'report' = 'campaign'
    campaignData: any;
    constructor(
        public _campaignNameUpSer: UpdateCampaignNameServiceService,
        private _api: ApiService,
        private _util: UtilService,
        public _mapping: MappingService,
        public _campaignReportSer: CampaignReportServiceService
    ) {
        this._campaignReportSer.isCampiagnDataLoad.subscribe((res:boolean) => {
            if (res == true) {
                this.campaignData = this._campaignReportSer.singleCampaignData;
            }
        })
    }

    ngOnInit(): void {}

    // change campaign name
    updateCampaignName() {
        if (this._campaignNameUpSer.updateNameForm.valid) {
            if (
                ((this._campaignNameUpSer.updateNameForm.controls.name.value !=
                this._campaignNameUpSer.campaignName && this.activePage == 'report') || (this._campaignNameUpSer.updateNameForm.controls.name.value !=
                    this._mapping.campaignName && this.activePage == 'campaign'))
            ) {
                const fd = new FormData();
                fd.append('campaign_id', this._campaignNameUpSer.campaignId);
                fd.append(
                    'name',
                    this._campaignNameUpSer.updateNameForm.controls.name.value
                );
                this._campaignNameUpSer.isLoading = true;
                this._api.postData('update-campaign-name', fd).subscribe({
                    next: (res: any) => {
                        if (res.success) {
                            if(this.activePage == 'report') {
                                this._campaignNameUpSer.campaignName =  this._campaignNameUpSer.updateNameForm.controls.name.value
                            } else if (this.activePage == 'campaign') {
                                this._mapping.campaignName =
                                this._campaignNameUpSer.updateNameForm.controls.name.value;
                            }
                            this._util.showToast(res.message);
                            this._campaignNameUpSer.isNameUpdate = false;
                            this._campaignNameUpSer.isLoading = false;
                        } else {
                            this._util.showToast(res.message, true);
                            this._campaignNameUpSer.isNameUpdate = false;
                        }
                    },
                    error: (err) => {
                        console.log('error', err);
                        this._campaignNameUpSer.isNameUpdate = false;
                        this._campaignNameUpSer.isLoading = false;
                        if (err instanceof Object) {
                            Object.entries(err).forEach(([key, value]) => {
                                console.log({ 'key value': key, key: key[0] });
                                if (key == 'name') {
                                    this._campaignNameUpSer.updateNameForm.controls[
                                        'name'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                                    this._util.showToast(
                                        this._campaignNameUpSer.updateNameForm.controls.name.getError(
                                            'lv'
                                        ),
                                        true
                                    );
                                }
                            });
                        }
                    },
                });
            } else {
                this._campaignNameUpSer.isNameUpdate = false;
                console.log(
                    'update name',
                    this._campaignNameUpSer.isNameUpdate
                );
            }
        }
    }

    editCampaignName() {
        console.log('check out side condition')
        if (!this._campaignNameUpSer.isNameUpdate) {
            console.log('check inside condition');
            this._campaignNameUpSer.isNameUpdate = true;
            if(this.activePage == 'report') {
                this._campaignNameUpSer.updateNameForm.controls.name.setValue(this._campaignNameUpSer?.campaignName);
            } else if (this.activePage == 'campaign') {
                this._campaignNameUpSer.updateNameForm.controls.name.setValue(this._mapping?.campaignName);
            }
            setTimeout(() => {
                console.log(this.nameInput);
                if (this.nameInput && this.nameInput.nativeElement) {
                    this.nameInput.nativeElement.focus();
                }
            }, 100);
        }
    }
}
